// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsAnnotationAdd_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0H4L4.29058 1.16233C5.00197 1.46879 5.5 2.17623 5.5 3C5.5 3.50722 5.31118 3.97035 5 4.32291V7H6V8H5V10L4 12V8H3V12L2 10V8H1V7H2V4.32291C1.68882 3.97035 1.5 3.50722 1.5 3C1.5 2.17623 1.99803 1.46879 2.70942 1.16233L3 0ZM2.5 3C2.5 2.44772 2.94772 2 3.5 2C4.05228 2 4.5 2.44772 4.5 3C4.5 3.55228 4.05228 4 3.5 4C2.94772 4 2.5 3.55228 2.5 3ZM4 7V4.93699C3.84019 4.97812 3.67265 5 3.5 5C3.32735 5 3.15981 4.97812 3 4.93699V7H4Z" class="svg-bg"/>
  <path d="M8 7L9 7V9H11V10H9V12H8V10H6V9L8 9V7Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 0H5.5L5.96319 1.15796C7.14757 1.55923 8 2.68007 8 4C8 4.61337 7.81592 5.18374 7.5 5.6589V9H9V11H7.5V13L5.5 16V11H4.5V16L2.5 13V11H1V9H2.5V5.6589C2.18408 5.18374 2 4.61337 2 4C2 2.68007 2.85243 1.55923 4.03681 1.15796L4.5 0ZM5.5 9V6.95852C5.3374 6.9858 5.17036 7 5 7C4.82964 7 4.6626 6.9858 4.5 6.95852V9H5.5ZM5 5C5.55228 5 6 4.55228 6 4C6 3.44772 5.55228 3 5 3C4.44772 3 4 3.44772 4 4C4 4.55228 4.44772 5 5 5Z" class="svg-bg"/>
  <path d="M11 10H13V12H15V14H13V16H11V14H9V12H11V10Z" class="svg-bg"/>
</svg>
`;
/**
 * IconAnnotationsAnnotationAdd is a generated icon component.
 */
let IconAnnotationsAnnotationAdd = IconAnnotationsAnnotationAdd_1 = class IconAnnotationsAnnotationAdd extends IconBaseElement {
    render() {
        return html `${IconAnnotationsAnnotationAdd_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsAnnotationAdd.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconAnnotationsAnnotationAdd = IconAnnotationsAnnotationAdd_1 = __decorate([
    customElement('zui-icon-annotations-annotation-add')
], IconAnnotationsAnnotationAdd);
export { IconAnnotationsAnnotationAdd };
